import { Controller } from "@hotwired/stimulus";

// Auto-opens an item modal on page load when the URL has
// ?open_item={id} (and optionally &open_item_type={type}).
//
// Cross-venue search (CAL-30) is what puts those params
// there: a search result links to the item's menu/venue
// page with ?open_item={id}&open_item_type={type}, and
// this controller scrolls to it and opens the modal.
//
// Usage, on the menu/venue content wrapper:
//     data-controller="restaurant-item-auto-open"
//   (so connect() runs on page load)
//
// This also documented a second flow, a login round-trip
// off a "Sign in to order" button, long after that button
// had stopped existing. Nothing on the customer ordering
// path asks anyone to sign in (CAL-496), so the flow, the
// setQueryParam action it called and the itemId value
// that fed it are all gone.
//
// Item types supported: restaurant_item, service_item,
// catalog_item: each renders with dom_id(item) as its
// wrapper element id, and exposes a turbo-frame link
// inside.
const ITEM_TYPES = [
  "restaurant_item",
  "service_item",
  "catalog_item",
];

export default class extends Controller {
  connect() {
    const url = new URL(window.location);
    const itemId = url.searchParams.get("open_item");
    if (!itemId) return;

    const explicitType = url.searchParams.get("open_item_type");
    const candidateTypes = explicitType
      ? [explicitType]
      : ITEM_TYPES;

    const itemElement = candidateTypes
      .map((t) => document.getElementById(`${t}_${itemId}`))
      .find(Boolean);

    // The params survive whenever this page can't act on
    // them, so a page that can still has them: the element
    // may be on a different page (e.g. the user landed on
    // a parent venue), or its card may render no link,
    // because that item type navigates instead of opening
    // a modal.
    if (!itemElement) return;

    const link = itemElement.querySelector("a[data-turbo-frame]");
    if (!link) return;

    url.searchParams.delete("open_item");
    url.searchParams.delete("open_item_type");
    history.replaceState({}, "", url);

    itemElement.scrollIntoView({ behavior: "instant", block: "center" });
    setTimeout(() => link.click(), 300);
  }
}
